import {Radio} from '@material-ui/core';
import React, {ReactElement} from 'react';

interface RadioProps {
  title: string;
  check: boolean;
  action(event: any): void;
  className: any;
}

const RadioComponent = (props: RadioProps): ReactElement => {
  const {title, check, action, className} = props;

  return (
    <Radio
      className={className ? className : ''}
      title={title}
      checked={check}
      onClick={(event: any) => {
        if (typeof action === 'function') {
          action(event);
        }
      }}
    />
  );
};

export default RadioComponent;
